import React from "react";
import {RecentlyViewedEmptyCard} from "../CardComponents/RecentlyViewedEmptyCard"

export const RecentlyView=()=>{
    return(
        <>
        <RecentlyViewedEmptyCard/>
        </>
    )
}